// extracted by css-extract-rspack-plugin
export default {"content":"content-M0rgA9"};